<script setup>
import Bugsnag from "@bugsnag/js";
import { ElPopover } from "element-plus";
import { ref, onMounted } from "vue";
import { useLmsSettingsStore } from "@/stores/useLmsSettingsStore";
import { http } from "@/composable/httpService";
import { useRoute } from "vue-router";
import { computed } from "vue";
import eventBus from "@/plugins/eventBus";

const route = useRoute();

const loading = ref(true);
const folders = ref([]);
const selectedStoreFromSwitch = ref(null);

const isResourceManager = computed(
  () => route.name === "filemanager" || route.name === "File Manager Folder"
);

const getFolders = () => {
  loading.value = true;

  const params = {};
  if (selectedStoreFromSwitch.value?.id) {
    params.store_id = selectedStoreFromSwitch.value.id;
  }
  
  http()
    .get("/v3/file-manager/folders", { params })
    .then(({ data }) => {
      folders.value = data.splice(0, 20);
      loading.value = false;
    })
    .catch((error) => {
      loading.value = false;
      Bugsnag.notify(error);
    });
};

const loadStoreFilter = () => {
  const storedStore = localStorage.getItem("selected_store");
  if (storedStore) {
    try {
      selectedStoreFromSwitch.value = JSON.parse(storedStore);
    } catch (error) {
      localStorage.removeItem("selected_store");
    }
  }
};
const handleStoreSwitch = (store) => {
  selectedStoreFromSwitch.value = store;
  getFolders();
};

onMounted(() => {
  loadStoreFilter();
  getFolders();
  const lmsSettingsStore = useLmsSettingsStore();
  if (lmsSettingsStore.isRestrictResourceManagement) {
    window.location.href = "/";
  }
  eventBus.$on('STORE_SWITCHED', handleStoreSwitch);
});
</script>
<template>
  <div v-bind="$attrs" v-if="!loading">
    <el-popover
      v-if="folders.length"
      :width="220"
      popper-style="padding: 5px !important;z-index: 3000 !important; background-color: #161616"
    >
      <template #reference>
        <router-link
          class="px-1 pt-1 text-sm w-full h-full flex justify-center items-center font-medium cursor-pointer"
          :class="{
            'text-kintz-primary-2 border-kintz-primary-2 border-b-2':
              isResourceManager,
            'hover:border-kintz-primary-2 border-b-2 border-transparent hover:text-kintz-primary-2 text-kintz-primary-4':
              !isResourceManager,
          }"
          to="/resource-manager"
        >
          Resource Manager
        </router-link>
      </template>
      <template #default>
        <div v-if="loading">
          <h3>Loading...</h3>
        </div>
        <div v-else class="w-full flex flex-col justify-start items-start">
          <div class="w-full" v-for="folder in folders" :key="folder.id">
            <a
              :href="'/resource-manager/' + folder.id"
              target="_blank"
              class="w-full px-2 py-2 text-sm flex justify-start items-start"
              :class="{
                'text-kintz-primary-2':
                  route.fullPath === `/resource-manager/${folder.id}`,
                'hover:text-kintz-primary-2 text-kintz-primary-4':
                  route.fullPath !== `/resource-manager/${folder.id}`,
              }"
              >{{ folder.name }}</a
            >
          </div>
        </div>
      </template>
    </el-popover>
    <router-link
      v-if="!folders.length && !loading"
      class="px-1 pt-1 text-sm w-full h-full flex justify-center items-center font-medium cursor-pointer"
      :class="{
        'text-kintz-primary-2 border-kintz-primary-2 border-b-2':
          isResourceManager,
        'hover:border-kintz-primary-2 border-b-2 border-transparent hover:text-kintz-primary-2 text-kintz-primary-4':
          !isResourceManager,
      }"
      to="/resource-manager"
    >
      Resource Manager
    </router-link>
  </div>
</template>
<style lang="scss" scoped></style>
